import { render } from "./StoriesSlider.vue?vue&type=template&id=e4efe7d2&scoped=true"
import script from "./StoriesSlider.vue?vue&type=script&lang=js"
export * from "./StoriesSlider.vue?vue&type=script&lang=js"

import "./StoriesSlider.vue?vue&type=style&index=0&id=e4efe7d2&lang=scss&scoped=true"

import exportComponent from "/var/www/html/punchline-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4efe7d2"]])

export default __exports__